import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {PortalNotifiationBySuperAdmin} from '../../../../../Redux/AdminPanel/CommentSlice'

const CreateNotification = ({show, handleClose}: any) => {
  const UserProfileData = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)

  const dispatch = useDispatch()
  const [data, setData] = useState({
    type: '',
    message: '',
  })

  const handleConfirm = () => {
    dispatch(
      PortalNotifiationBySuperAdmin({
        userTo: [UserProfileData?._id],
        message: data?.message,
        type: data?.type,
      })
    )
    handleClose()
    setData({
      type: '',
      message: '',
    })
  }

  const handleChange = (e: any) => {
    setData({...data, [e.target.name]: e.target.value})
  }
  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-400px'
        className='vh-100 '
        size='sm'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'><h2>Add Portal Notification</h2></div>
        <div className='modal-body p-10 py-8'>
          <div className='col mb-4'>
            <label className=' col-form-label required fw-bold fs-6'>Type</label>

            <div className='row'>
              <div className='col fv-row'>
                <select
                  value={data?.type}
                  name='type'
                  className='form-select form-select-solid form-select-lg fw-bold'
                  onChange={handleChange}
                >
                  <option value=''>Select Type</option>
                  <option value='system'>System</option>
                  <option value='inbox'>Indox</option>
                </select>
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'></div>
                </div>
              </div>
            </div>
          </div>
          <div className='col'>
            <label className=' col-form-label required fw-bold fs-6'>Message</label>

            <div className='row'>
              <div className='col fv-row'>
                <input
                  name='message'
                  type='text'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder='Description'
                  onChange={handleChange}
                />
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'></div>
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex flex-center mt-7'>
            <div id='kt_drawer_chat_close'>
              <button
                type='button'
                onClick={handleClose}
                className='btn btn-sm gray_bg_purple me-2'
              >
                Cancel
              </button>
            </div>

            <button
              type='submit'
              className='btn btn-sm btn-light btn-primary fw-500   w-100px p-3 border border-primary'
              disabled={data.message == '' || data.type == ''}
              onClick={handleConfirm}
            >
              <span className='indicator-label'>Submit</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CreateNotification
